// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__3CUB6","icon":"style_icon__10SLM"};